import React, { useEffect, useState } from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { baseurladdress } from "../baseurl";
import { Modal, Button, ModalHeader, ModalFooter } from "react-bootstrap";
import { use } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

function Shiftlist() {
  const Swal = require("sweetalert2");
  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");
  const [shift, setShift] = useState("");
  const [type, setType] = useState("");
  const [fromtime, setFromtime] = useState("");
  const [totime, setTotime] = useState("");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [edittype, setedittype] = useState(false);
  const [typeid, setTypeid] = useState("");
  const [edtypename, setEdtypename] = useState("");
  const [edtypefrom, setEdtypefrom] = useState("");
  const [edtypeto, setEdtypeto] = useState("");
  const [edstatus, setEdstatus] = useState("");
  const [statval, setstatval] = useState("");
    const [leadtime, setleadtime] = useState("");
    const [Leadtime, setLeadtime] = useState("");//add new shift types
  const handleShift = () => {
    setShift(true);
  };

  // add new Shft Types

  const handleTypeSubmit = (e) => {
    e.preventDefault();
    if (!type.trim) {
      document.getElementById("shifttype").focus();
      return;
    }
    if (!fromtime) {
      document.getElementById("fromTime").focus();
      return;
    }
    if (!totime) {
      document.getElementById("toTime").focus();
      return;
    }
    const data = {
      type_name: type,
      type_from: fromtime,
      type_to: totime,
      type_crtdby: accessuserid,
      lead_time: Leadtime,
    };
    axios
      .post(baseurladdress + `addshifttypes`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "success",
            title: "Shift Type added successfully",
          });
          setShift(false);
          setType("");
          setFromtime("");
          setTotime("");
          setLeadtime("");
        
          GetAllShiftTypes();

        } else {
          alert("Failed");
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

    // Get all Shift Types
    const formatTime = (time) => {
        if (!time) return "-";

        return new Date(`1970-01-01T${time}`).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };
  const GetAllShiftTypes = () => {
    axios.get(baseurladdress + `findallshifttypes`, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
      .then((res) => {
        const datas = res.data.response;
        console.log("itemss" + datas);
        //alert(datas);
        const types = datas.map((item, index) => (
          <tr id={"chk" + item.type_id} style={{ textAlign: "left" }}>
            <td>{index + 1}</td>
            <td>{item.type_name}</td>
                <td>{formatTime(item.type_from)}</td>
                <td>{formatTime(item.type_to)}</td>
            <td>
              <div>
                {(() => {
                  if (item.type_status == 0) {
                    return (
                      <div>
                        <span class="badge bg-danger">Inactive</span>
                      </div>
                    );
                  } else if (item.type_status == 1) {
                    return (
                      <div>
                        <span class="badge bg-success">Active</span>
                      </div>
                    );
                  }
                })()}
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              <i
                class="text-primary fa fa-pencil-square-o"
                style={{ cursor: "pointer" }}
                onClick={() => handleEditType(item.type_id)}
              ></i>
            </td>
          </tr>
        ));

        setData(types);
      })
      .catch((error) => {
        alert(error);
      });
  };
  useEffect(() => {
    GetAllShiftTypes();
  }, []);

  // Edit shift_type 

  // const handleEditType = (typeId) => {
  //   setedittype(true);
  //   setTypeid(typeId);
  //   console.log(typeId, "userIduserIduserId");
  //   axios.get(baseurladdress + `editshifttype/` + typeId, {
  //     headers: { Authorization: `Bearer ${accesstoken}` },
  //   })
  //     .then((res) => {
  //       const data = res.data.response;
  //       setEdtypename(data[0].type_name);
  //       setEdtypefrom(data[0].type_from);
  //       setEdtypeto(data[0].type_to);
  //       setEdstatus(data[0].type_status);
  //       setleadtime(data[0].lead_time);
  //     })
  //     .catch((error) => {
  //       alert(error);
  //     });
  // }
// const handleEditType = (typeId) => {
//   setedittype(true);
//   setTypeid(typeId);

//   axios.get(baseurladdress + `editshifttype/` + typeId, {
//     headers: { Authorization: `Bearer ${accesstoken}` },
//   })
//     .then((res) => {
//       const data = res.data.response[0];

//       setEdtypename(data.type_name);
//       setEdtypefrom(data.type_from);
//       setEdtypeto(data.type_to);
//       setEdstatus(data.type_status);

//       // Fetch exact DB value
//       setleadtime(data.lead_time);
//     })
//     .catch((error) => {
//       alert(error);
//     });
// };
//   //update the shift types 
//   const handleUpdatetypes = (e) => {
//     e.preventDefault();
//     var data = {
//       type_name: edtypename,
//       type_from: edtypefrom,
//       type_to: edtypeto,
//       type_status: edstatus,
//       lead_time: leadtime,
//       type_updtby: accessuserid,
//       type_id: typeid,
//     };
//     axios.post(baseurladdress + ``, data, {
//       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//     })
//       .then((result) => {
//         console.log("reslt:", result);
//         const Data = result.data.status;
//         if (Data == "success") {
//           const Toast = Swal.mixin({
//             toast: true,
//             position: "top-end",
//             showConfirmButton: false,
//             timer: 2500,
//             timerProgressBar: true,
//             didOpen: (toast) => {
//               toast.addEventListener("mouseenter", Swal.stopTimer);
//               toast.addEventListener("mouseleave", Swal.resumeTimer);
//             },
//           });
//           Toast.fire({
//             icon: "success",
//             title: "Shift Type Data Updated successfully",
//           });
//           setedittype(false);
//           GetAllShiftTypes();
//         }
//         else {
//           alert("Failed");
//         }
//       })
//       .catch((error) => {
//         alert(error);
//       });
//   }
const handleEditType = (typeId) => {
  setedittype(true);
  setTypeid(typeId);

  axios
    .get(baseurladdress + `editshifttype/` + typeId, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then((res) => {
      const data = res.data.response[0];

      setEdtypename(data.type_name);
      setEdtypefrom(data.type_from);
      setEdtypeto(data.type_to);
      setEdstatus(data.type_status);

      // Fetch exact DB value
      setleadtime(data.lead_time);
    })
    .catch((error) => {
      console.log(error);
      alert(error);
    });
};


// UPDATE SHIFT TYPES
const handleUpdatetypes = (e) => {
  e.preventDefault();

  var data = {
    type_name: edtypename,
    type_from: edtypefrom,
    type_to: edtypeto,
    type_status: edstatus,
    lead_time: leadtime,
    type_updtby: accessuserid,
    type_id: typeid,
  };

  axios
    .post(
      baseurladdress + `updateshifttype`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then((result) => {
      console.log("result:", result);

      const Data = result.data.status;

      if (Data === "success") {

        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Shift Type Data Updated successfully",
        });

        setedittype(false);
        GetAllShiftTypes();

      } else {
        alert("Failed");
      }
    })
    .catch((error) => {
      console.log(error);
      alert(error);
    });
};
  $(function () {
    setTimeout(function () {
      $('#shiftlist').DataTable();
    }, 1000);
  });

  return (
    <div>
      <Topnavbar />

      <Sidennav />
      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">
            {/* /# row */}
            <section id="main-content">
              <div class="card">
                <div class="card-header" style={{ color: "black" }}>
                  <h6 class="card-title"> SHIFT TYPE DETAILS</h6>
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn plus-icon d-flex align-items-center"
                      id="addshiftbtn"
                      onClick={handleShift}
                      style={{ marginRight: "50px" }} // Adjust spacing as needed
                    >
                      <span style={{ fontSize: "1.2rem" }}>
                        <i className="fa fa-plus-circle text-success"></i>
                      </span>
                      <span
                        style={{
                          fontSize: "0.7rem",
                          color: "black",
                          padding: "5px",
                        }}
                      >
                        {" "}
                        ADD NEW
                      </span>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered table-responsive-sm"
                            id="shiftlist"
                          >
                            <thead style={{ textAlign: "left" }}>
                              <tr>
                                <th>Sl.No</th>
                                <th>Shift Type</th>
                                <th>Shift Start Time</th>
                                <th>Shift End Time</th>
                                <th>Status</th>
                                <th>Edit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Model box for Add   */}
              <Modal
                className="modal-size md"
                show={shift}
                onHide={() => {
                  setShift(true);
                }}
              >
                <Modal.Header>
                  <h6>ADD SHIFT DETAILS</h6>
                  <span
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShift(false);
                    }}
                  >
                    ×
                  </span>
                </Modal.Header>
                <Modal.Body className="css">
                  <div className="row">
                    <div className="col-md-6">
                      <h6>Shift Type</h6>
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="shifttype"
                        value={type}
                        onChange={(e) => setType(e.target.value)} autoComplete="off" placeholder="Enter shift type"
                      ></input>
                    </div>
                    <div className="col-md-6">
                      <h6>Shift starting Time</h6>
                      <input
                        type="time"
                        className="form-control"
                        id="fromTime"
                        value={fromtime}
                        onChange={(e) => setFromtime(e.target.value)} autoComplete="off"
                      ></input>
                    </div>
                    <div className="col-md-6">
                      <h6>Shift Ending Time</h6>
                      <input
                        type="time"
                        className="form-control"
                        id="toTime"
                        value={totime}
                        onChange={(e) => setTotime(e.target.value)} autoComplete="off"
                      ></input>
                    </div>

                                      <div className="col-md-6">
                                          <h6>Shift Lead Time</h6>

                                          <input
                                              type="time"
                                              className="form-control"
                                              value={Leadtime ? Leadtime.substring(0, 5) : ""}
                                              onChange={(e) => {
                                                  const value = e.target.value;
                                                  setLeadtime(value ? `${value}:00` : "");
                                              }}
                                              autoComplete="off"
                                          />
                                      </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="saveuser"
                          onClick={handleTypeSubmit}
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              {/* end */}


              {/* Model box for Edit   */}
              <Modal
                className="modal-size md"
                show={edittype}
                onHide={() => {
                  setedittype(true);
                }}
              >
                <Modal.Header>
                  <h6>EDIT SHIFT DETAILS</h6>
                  <span
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setedittype(false);
                    }}
                  >
                    ×
                  </span>
                </Modal.Header>
                <Modal.Body className="css">
                  <div className="d-flex justify-content-end">
                    <Form>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={edstatus}
                        label="Status"
                        value={statval}
                        onClick={() => { setEdstatus(!edstatus); }}
                        onChange={(event) => {
                          var checked = event.target.checked; if (checked == true) { setEdstatus(1); }
                          else { setEdstatus(0); }
                        }}
                      />
                    </Form>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <h6>Shift Type</h6>
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="shifttype"
                        value={edtypename}
                        onChange={(e) => setEdtypename(e.target.value)} autoComplete="off"
                      ></input>
                    </div>
                    <div className="col-md-6">
                      <h6>Shift starting Time</h6>
                      <input
                        type="time"
                        className="form-control"
                        id="fromTime"
                        value={edtypefrom}
                        onChange={(e) => setEdtypefrom(e.target.value)} autoComplete="off"
                      ></input>
                    </div>
                    <div className="col-md-6">
                      <h6>Shift Ending Time</h6>
                      <input
                        type="time"
                        className="form-control"
                        id="toTime"
                        value={edtypeto}
                        onChange={(e) => setEdtypeto(e.target.value)} autoComplete="off"
                      ></input>
                    </div>
                    <div className="col-md-6">
                      <h6>Shift Leading Time</h6>
                      <input
                        type="text"
                        className="form-control"
                        id="toLTime"
                        value={leadtime}
                        onChange={(e) => setleadtime(e.target.value)} autoComplete="off"
                      ></input>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          id="saveshift"
                          onClick={handleUpdatetypes}
                        >
                          UPDATE
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              {/* end */}

              {/* /# column */}
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shiftlist;
